<template>
  <div v-if="active" class="notifications-list">
    <h5
      v-if="notificationsList.length > 0"
      class="notifications-list__title"
    >
      Notificações
    </h5>

    <div class="notifications-list__wrapper">
      <div
        v-if="notificationsList.length === 0"
        class="notifications-list__none"
      >
        <h6 class="notifications-list__title">
          Você não tem nenhuma nova notificação.
        </h6>
      </div>

      <h6
        v-if="newNotifications.length > 0"
        class="notifications-list__sub-title"
      >
        Novas
      </h6>

      <ul
        v-if="newNotifications.length > 0"
        class="notifications-list__list"
      >
        <li
          v-for="notification in newNotifications"
          :key="`newNotification_${notification.id}`"
          class="notifications-list__item notifications-list__item--new"
          @click.stop.prevent="$emit('read-notification', notification.id)"
        >
          <div class="notifications-list__img">
            <img src="/static/img/favicon.png" alt="">
          </div>

          <div class="notifications-list__text-wrapper">
            <span class="notifications-list__text-title">
              {{ notification.data.title }}
            </span>

            <span class="notifications-list__text-date">
              {{ notification.created_at | TO_DATE_TIME }}
            </span>
          </div>
        </li>
      </ul>

      <h6
        v-if="oldNotifications.length > 0"
        class="notifications-list__sub-title"
      >
        Anteriores
      </h6>

      <ul
        v-if="oldNotifications.length > 0"
        class="notifications-list__list"
      >
        <li class="notifications-list__item"
          v-for="(notification, index) in oldNotifications"
          :key="`oldNotification_${index}`"
        >
          <div class="notifications-list__img">
            <img src="/static/img/favicon.png">
          </div>

          <div class="notifications-list__text-wrapper">
            <span class="notifications-list__text-title">
              {{ notification.data.title }}
            </span>

            <span class="notifications-list__text-date">
              {{ notification.created_at | TO_DATE_TIME }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: () => true
    },

    notificationsList: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  computed: {
    newNotifications () {
      return this.notificationsList.filter(item => !item['is_read'])
    },

    oldNotifications () {
      return this.notificationsList.filter(item => item['is_read'])
    }
  }
}
</script>
